export const erc20Abi = [
	"function name() view returns (string)",
	"function symbol() view returns (string)",
	"function decimals() view returns (uint8)",
	"function totalSupply() view returns (uint256)",
	"function balanceOf(address owner) view returns (uint256)",
	"function transfer(address to, uint256 amount)"
];

export const tokenVaultAbi = [
	'function claim(address user, address token, uint256 amount, bytes signature, bytes32 nonce) external payable',
	'function getBalance(address token) external view returns (uint256)',
	'function getTokenAInfo() external view returns (address tokenAddress, uint256 balance)',
	'function getTokenBInfo() external view returns (address tokenAddress, uint256 balance)',
	'function lastMintTime(address) external view returns (uint256)',
	'function getlastMintTime(address user) external view returns (uint256 time)',
	'function mint() external payable',
	'function mintSigned(uint256 ethValue, uint256 nonce, bytes calldata signature) external payable returns (bytes32)',
	'function mintAmount() view returns (uint256)',
	'function mintCooldown() view returns (uint256)',
	'function minEthValue() view returns (uint256)',
	'function setMinEthValue(uint256 _newMinEthValue)',
	'function setMintAmount(uint256 _newMintAmount)',
	'function setSigner(address _newSigner) external',
	'function signer() external view returns (address)',
	'function tokenA() external view returns (address)',
	'function tokenB() external view returns (address)',
	'function transferOwnership(address newOwner)',
	'function usedNonces(bytes32) external view returns (bool)',
	'function withdraw() external',
	'function withdrawa() external'
];